import { create } from 'zustand';

export type LoadingStatusStore = {
  isChatPageLoading: boolean;
  loadingBg: string;
  setChatPageLoadingStart: (loadingBg: string) => void;
  setChatPageLoadingEnd: () => void;
};

const useChatPageLoadingStatus = create<LoadingStatusStore>((set) => ({
  isChatPageLoading: false,
  loadingBg: '',
  setChatPageLoadingStart: (loadingBg) => {
    set(() => ({ isChatPageLoading: true, loadingBg: loadingBg }));
  },
  setChatPageLoadingEnd: () => {
    set(() => ({ isChatPageLoading: false }));
  },
}));

export default useChatPageLoadingStatus;
